import React, { Component, useState, useEffect } from "react"
import Box from "@material-ui/core/Box"
import Button from "@material-ui/core/Button"
import Container from "@material-ui/core/Container"
import Grid from "@material-ui/core/Grid"
import MenuItem from "@material-ui/core/MenuItem"
import Paper from "@material-ui/core/Paper"
import TextField from "@material-ui/core/TextField"
import Typography from "@material-ui/core/Typography"
import { Link } from "react-router-dom"
import PublicLayout from "../../common/layouts/PublicLayout"
import { connect } from "react-redux"
import { getProfile } from "../../Redux"
import ApiServices from "../../services/ApiServices"
import AlertBox from "../../common/alert/AlertBox"
import Loading from "../Loading/Loading"
import { Helmet } from "react-helmet"
import { toast } from "react-toastify"
import { sendAnalyticsEvent } from "../../Utils/analytics"
import { PAGE_VIEW_EVENT } from "../../Utils/analyticsEvents"
import "./NewPricing.css"

const NewPricing = (props) => {
  useEffect(() => {
    sendAnalyticsEvent(PAGE_VIEW_EVENT, { "Page Name": "Pricing" })
  }, [])

  const [state, setState] = useState({
    name: "",
    businesses: [],
    business: "Payment Related",
    phone: "",
    email: "",
    organisation: "",
    designation: "",
    subject: "LabelBlind®️ Pricing Enquiry",
    message: "",
    success: "none",
    loading: false,
  })

  const handleSubmit = async (evt) => {
    evt.preventDefault()
    let postData = {
      type: "CUSTOM_MAIL",
      lbUserId: 123,
      details: {
        business: state.business,
        name: state.name,
        email: state.email,
        phone: state.phone,
        organisation: state.organisation,
        subject: "LabelBlind®️ Pricing Enquiry",
        message: state.message,
      },
    }
    try {
      console.log("State Value", state)
      let response = await ApiServices.sendCustomEMail(postData)
      // console.log("Email send response: ", response);
      toast.success("Email sent successfully!")
      setState({
        name: "",
        businesses: [],
        business: "Payment Related",
        phone: "",
        email: "",
        organisation: "",
        designation: "",
        subject: "LabelBlind®️ Pricing Enquiry",
        message: "",
        success: true,
        loading: false,
      })
      return false
    } catch (e) {
      toast.error("Something went wrong!")
      return false
    }
  }

  const handleClose = () => {
    setState({
      open: false,
    })
  }

  return (
    <div>
      <Helmet>
        <title>FoLSol®| Pricing</title>
        <meta name="description" content="Food Label Solution Pricing" />
        <meta name="keywords" content="" />
      </Helmet>

      {state.loading ? (
        <Loading />
      ) : (
        <PublicLayout>
          {state.success === true ? (
            <AlertBox message={"Mail Sent Successfully !"} type={"success"} />
          ) : state.success === false ? (
            <AlertBox message={"Something went wrong !"} type={"error"} />
          ) : (
            ""
          )}

          <main className="main">
            <Box className="container">
              <Container>
                <Typography
                  component="h3"
                  variant="h3"
                  className="contact-heading"
                >
                  {" "}
                  Need a Quote ? Contact Us
                </Typography>
                <div className="flex-grow">
                  <Grid container spacing={3}>
                    <Grid item lg={12} xs={12}>
                      <Paper className="p-2">
                        <Typography
                          varient={"subtitle2"}
                          className="contact-content"
                        >
                          We are happy to answer any question that you may have.
                          <br /> For any further questions, just fill the form
                          below or mail us at{" "}
                          <a href="mailto:support@foodlabelsolutions.com">
                            support@foodlabelsolutions.com
                          </a>
                        </Typography>
                        <form onSubmit={handleSubmit}>
                          <Grid container spacing={3}>
                            <Grid item lg={4} xs={12}>
                              <TextField
                                select
                                label="Select Business"
                                value={state.business}
                                onChange={(e) =>
                                  setState({
                                    ...state,
                                    business: e.target.value,
                                  })
                                }
                                required
                              >
                                {/* <MenuItem value={`Business Enquiry`}>Business Enquiry</MenuItem> */}
                                <MenuItem value={"Payment Related"}>
                                  Payment Related
                                </MenuItem>
                                {/* <MenuItem value={`Tech Troubleshoot`}>Tech Troubleshoot</MenuItem> */}
                                {/* <MenuItem value={`Work with us`}>Work with us</MenuItem> */}
                                {/* <MenuItem value={`Others`}>Others</MenuItem> */}
                              </TextField>
                            </Grid>
                            <Grid item lg={4} xs={12}>
                              <TextField
                                label="Name"
                                id="demo-simple-select"
                                value={state.name}
                                onChange={(e) =>
                                  setState({ ...state, name: e.target.value })
                                }
                                required
                              />
                            </Grid>
                            <Grid item lg={4} xs={12}>
                              <TextField
                                label="Email"
                                type="email"
                                id="demo-simple-select"
                                value={state.email}
                                onChange={(e) =>
                                  setState({ ...state, email: e.target.value })
                                }
                                required
                              />
                            </Grid>
                          </Grid>
                          <Grid container spacing={3}>
                            <Grid item lg={4} xs={12}>
                              <TextField
                                label="Phone no"
                                id="demo-simple-select"
                                value={state.phone}
                                onChange={(e) =>
                                  setState({ ...state, phone: e.target.value })
                                }
                                required
                              />
                            </Grid>
                            <Grid item lg={4} xs={12}>
                              <TextField
                                label="Organisation"
                                id="demo-simple-select"
                                value={state.organisation}
                                onChange={(e) =>
                                  setState({
                                    ...state,
                                    organisation: e.target.value,
                                  })
                                }
                                required
                              />
                            </Grid>
                            <Grid item lg={4} xs={12}>
                              <TextField
                                label="Designation"
                                id="demo-simple-select"
                                value={state.designation}
                                onChange={(e) =>
                                  setState({
                                    ...state,
                                    designation: e.target.value,
                                  })
                                }
                                required
                              />
                            </Grid>
                          </Grid>
                          <Grid container spacing={3}>
                            <Grid item lg={12} xs={12}>
                              <TextField
                                label="Enter Subject"
                                id="demo-simple-select"
                                // value={state.subject}
                                value={state.subject}
                                // onChange={e => setState({ subject: e.target.value })}
                                InputProps={{
                                  readOnly: true,
                                }}
                              />
                            </Grid>
                          </Grid>
                          <Grid container spacing={3}>
                            <Grid item lg={12} xs={12}>
                              <TextField
                                label="Write message here..."
                                id="outlined-multiline-static"
                                multiline
                                rows={5}
                                value={state.message}
                                onChange={(e) =>
                                  setState({
                                    ...state,
                                    message: e.target.value,
                                  })
                                }
                              />
                            </Grid>
                          </Grid>
                          <Grid container spacing={3}>
                            <Grid item lg={12} xs={12}>
                              <Button
                                color="primary"
                                variant="contained"
                                type="submit"
                              >
                                Send
                              </Button>
                            </Grid>
                          </Grid>
                        </form>
                      </Paper>
                    </Grid>
                  </Grid>
                </div>
              </Container>
            </Box>
          </main>
        </PublicLayout>
      )}
    </div>
  )
}

export default NewPricing
